/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LaborCostGroupType {
  Task = 'task',
  Labor = 'labor',
  Budget = 'budget',
  CostType = 'costType'
}
